import { getCategoriesArticle } from '@app/utils/blog';
import { getArticlesByCategories } from '@app/services/blog';
import { snackbar } from '$lib/stores';
import { getCMSComponents } from '@app/components/cms';

export const load = async ({ parent, fetch }) => {
	let preloadError;
	const data = await parent();

	const article = data?.story;
	article.content.content = await getCMSComponents(article?.content?.content);

	try {
		const endArticleBloc = (await (await fetch(`/cms/blog/articles/end-article-content`)).json())
			.data.story;
		const similarArticles = await (
			await getArticlesByCategories(getCategoriesArticle(article), 4, 1, fetch)
		)?.stories;

		return {
			article,
			similarArticles,
			endArticleBloc: await getCMSComponents(endArticleBloc?.content.body)
		};
	} catch (e) {
		preloadError = e;
		snackbar.open({ message: preloadError });
	}
};
